// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"1cdc03cc","384":"6c4e7159","453":"ce041d04"}[chunkId] + ".chunk.js";
};